module.exports = __webpack_public_path__ + "static/media/spin_cash30.823d6061.png";